import { Close, ContentCopyOutlined } from '@mui/icons-material'
import { Box, DialogActions, DialogContent } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomDialog from '@/components/feedback/CustomDialog'
import CustomButton from '@/components/inputs/CustomButton'
import { useAlertContext } from '@/contexts/AlertContext'
import { TextEditor } from '@/features/controller/configuration/components/textEditor/TextEditor'
import { TextEditorLanguage } from '@/features/controller/configuration/types'

interface ModbusTestingScriptDialogProps {
  onClose: () => void
  open: boolean
  script: string
}

export function ModbusTestingScriptDialog({ onClose, open, script }: Readonly<ModbusTestingScriptDialogProps>) {
  const { t } = useTranslation()
  const { pushAlert } = useAlertContext()

  const onCopyButtonClick = async () => {
    await navigator.clipboard.writeText(script)

    pushAlert({
      message: t('controllers.configuration.power_meters.modbus.testing_script.copied_to_clipboard'),
      severity: 'success',
    })
  }

  return (
    <CustomDialog
      open={open}
      size="large"
      title={t('controllers.configuration.power_meters.modbus.testing_script.title')}
      onClose={onClose}
    >
      <DialogContent>
        <Box sx={{ pt: '10px' }}>
          <TextEditor language={TextEditorLanguage.shell} value={script} />
        </Box>
      </DialogContent>
      <DialogActions>
        <CustomButton
          color="primary"
          fullWidth={false}
          startIcon={<ContentCopyOutlined />}
          variant="outlined"
          onClick={onCopyButtonClick}
        >
          {t('controllers.configuration.power_meters.modbus.testing_script.copy_to_clipboard')}
        </CustomButton>
        <CustomButton color="primary" fullWidth={false} startIcon={<Close />} variant="outlined" onClick={onClose}>
          {t('common.button.close')}
        </CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}
